import BaseApi from "@api/base.api";
import Http from "@services/http.js";

export default class RecentSearchesApi extends BaseApi {
    static get entity() {
        return "search/recent";
    }

    static async getRecentSearches(params = {}) {
        return await Http.get(this.entity, params);
    }

    static async saveSearch(data) {
        return await Http.post("search/save", data);
    }

    static async getSavedSearches(params = {}) {
        return await Http.get("search/saved", params);
    }

    static async deleteSavedSearch(savedSearchId) {
        return await Http.delete("search/saved", { saved_search_id: savedSearchId });
    }

    static async updateSavedSearchName(savedSearchId, name) {
        return await Http.put("search/saved/name", {
            saved_search_id: savedSearchId,
            name: name
        });
    }
}
